/* eslint-disable */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DropDown from '../../common/DropDown';
import PermissionComponent from '../../common/PermissionComponent';

import history from '../../../history';

export default class StatusDropDown extends PermissionComponent {
    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);
    }

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        return (
            <DropDown
                filterKey="status"
                options={this.getOptions()}
                selected={currentUrlParams.get('status')}
                defaultSelection={this.getDefaultSelection()}
                renderSelected={this.renderSelected}
                onFilterChange={this.props.onFilterChange}
                renderOption={this.renderOption}
                defaultSelectionFromParam={true}
            />
        );
    }

    renderSelected = (value, isOpen) => (
        <div
            className={`dropdown-placeholder bullet bullet-status-${
                value.value || 'all'
            }`}
        >
            {value.label}
        </div>
    );

    renderOption = option => (
        <div className={`bullet bullet-status-${option.value || 'all'}`}>
            {option.label}
        </div>
    );

    getOptions = () =>
        [
            {
                label: 'Open',
                value: 'OP',
            },
        ]
            .concat(
                this.context.user?.isAgent
                    ? [
                          {
                              label: 'Open in Emergency',
                              value: 'OE',
                          },
                      ]
                    : [],
            )
            .concat(
                this.context.user?.isAgent &&
                    this.context.user.agency.features.indexOf('backups') > -1
                    ? [
                          {
                              label: 'Open for backup',
                              value: 'OB',
                          },
                      ]
                    : [],
            )
            .concat([
                {
                    label: 'Confirmed',
                    value: 'CF',
                },
                {
                    label: 'Completed',
                    value: 'CP',
                },
                {
                    label: 'In Checkout ',
                    value: 'IC',
                },
                {
                    label: 'Cancelled',
                    value: 'CA',
                },
                {
                    label: 'All Statuses',
                    value: '',
                },
            ]);

    getDefaultSelection() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (currentUrlParams.get('status')) {
            const selected = this.getOptions().find(option =>
                option.value.includes(currentUrlParams.get('status')),
            );
            if (selected) {
                return selected;
            }
            return this.defaultSelection;
        }
        return this.defaultSelection;
    }

    defaultSelection = {
        label: 'All Statuses',
        value: '',
    };
}
